/**
 * Validates that all activities in the Gantt chart have a valid unique_correlative_id
 * @param {Object} gantt - The Gantt chart object
 * @returns {boolean} - Returns true if all activities have a valid unique_correlative_id, false otherwise
 */
export const validateAllActivityUIDs = (gantt) => {
  const activities = gantt.getTaskByTime();

  const invalidActivity = activities.find(
    ({ unique_correlative_id }) => !unique_correlative_id
  );

  return !invalidActivity;
};
